<template>
  <div class="space-y-3">
    <div v-for="(item, index) in modelValue" :key="index" class="flex gap-2">
      <BaseInput
        :model-value="item"
        class="flex-1"
        :placeholder="placeholder"
        @update:modelValue="updateItem(index, $event)"
      />
      <BaseButton variant="ghost" type="button" class="shrink-0 text-danger" @click="remove(index)">
        <AppIcon name="Trash2" :size="16" />
      </BaseButton>
    </div>
    <BaseButton variant="secondary" size="sm" type="button" @click="add">
      <AppIcon name="Plus" :size="16" />
      {{ addLabel }}
    </BaseButton>
  </div>
</template>

<script>
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import AppIcon from '@/components/ui/AppIcon.vue'

export default {
  name: 'AdminStringList',
  components: { BaseInput, BaseButton, AppIcon },
  props: {
    modelValue: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Enter value' },
    addLabel: { type: String, default: 'Add item' },
  },
  emits: ['update:modelValue'],
  methods: {
    updateItem(index, value) {
      const next = [...this.modelValue]
      next[index] = value
      this.$emit('update:modelValue', next)
    },
    add() {
      this.$emit('update:modelValue', [...this.modelValue, ''])
    },
    remove(index) {
      const next = [...this.modelValue]
      next.splice(index, 1)
      this.$emit('update:modelValue', next)
    },
  },
}
</script>
